class VerticalArticles extends HTMLElement {
  constructor() {
    super();

    this.pos = 0;
    this.plus = 0;
  }

  connectedCallback() {
    this.content = this.querySelector(".vertical-articles--content");
    this.inner = this.querySelector(".vertical-articles--inner");
    this.upButton = this.querySelector(".vertical-articles--up-button");
    this.downButton = this.querySelector(".vertical-articles--down-button");
    this.articles = this.querySelectorAll(".rao-blog__all--article");

    if(window.innerWidth < 700) {
      this.plus = 1;
    } else {
      this.plus = 2;
    }

    window.addEventListener("resize", function() {
      if(window.innerWidth < 700) {
        this.plus = 1;
      } else {
        this.plus = 2;
      }
    });

    this.init();
  }

  init() {
    if(window.innerWidth < 700) {
      this.content.style.setProperty("--inner-height", `${this.getHeight(this.articles[this.pos + this.plus])}px`);
    } else {
      this.content.style.setProperty("--inner-height", `${this.getHeight(this.articles[this.pos + this.plus])}px`);
    }

    this.upButton.addEventListener("click", this.moveUp.bind(this));
    this.downButton.addEventListener("click", this.moveDown.bind(this));
  }

  moveDown() {
    if(this.pos != this.articles.length - 1 - this.plus) {
      this.pos++;

      if(this.pos == this.articles.length - 1 - this.plus) {
        this.content.style.setProperty("--inner-height", `${this.articles[this.pos + this.plus].getBoundingClientRect().bottom - this.content.getBoundingClientRect().top}px`);
      } else {
        this.content.style.setProperty("--inner-height", `${this.getHeight(this.articles[this.pos + this.plus])}px`);
      }

      if(this.pos == this.articles.length - 1 - this.plus) {
        this.downButton.classList.add("disabled");
      }

      this.upButton.classList.remove("disabled");
    }
  }

  moveUp() {
    if(this.pos != 0) {
      this.pos--;
      this.content.style.setProperty("--inner-height", `${this.getHeight(this.articles[this.pos + this.plus])}px`);

      if(this.pos == 0) {
        this.upButton.classList.add("disabled");
      }

      this.downButton.classList.remove("disabled");
    }
  }

  getHeight(element) {
    return element.getBoundingClientRect().bottom - element.getBoundingClientRect().height / 2 - this.content.getBoundingClientRect().top
  }
}

customElements.define("vertical-articles", VerticalArticles);

class ContactButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", this.show.bind(this));
  }

  show() {
    const overlayContainer = document.querySelector("rao-tooltip-container");
    overlayContainer.show(this.querySelector(".horizontal-contact--popup-content").outerHTML); 
  }
}

customElements.define("contact-button", ContactButton);

class KlantenservicePage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sections = document.querySelectorAll(".shopify-section:not(.shopify-section-group-header-group):not(.shopify-section-group-overlay-group):not(.shopify-section-group-footer-group)");
    for(const section of sections) {
      if(!section.querySelector("klantenservice-page")) {
        const clonedSection = section.cloneNode(true);
        section.remove();
        this.appendChild(clonedSection);
      }
    }
  }
}

customElements.define("klantenservice-page", KlantenservicePage);

class HorizontalArticles extends HTMLElement {
  #readMoreBtn = null;
  #showAmount = 5;
  #articles = null;
  #articleContainer = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this.#articleContainer = this.querySelector(".horizontal-articles--articles");
    this.#articles = this.querySelectorAll(".horizontal-articles--article");

    if(this.#articles.length > 5) {
      this.#articleContainer.style.setProperty("--height", `${this.#articles[4].getBoundingClientRect().bottom - this.#articleContainer.getBoundingClientRect().top}px`);
      this.classList.add("remove-hide");
    }

    this.#readMoreBtn = this.querySelector(".horizontal-articles--read-more");
    if(this.#readMoreBtn) {
      this.#readMoreBtn.addEventListener("click", this.showMore.bind(this));
    }
  }

  showMore() {
    this.#showAmount += 5;
    if(this.#articles.length > this.#showAmount) {
      this.#articleContainer.style.setProperty("--height", `${this.#articles[this.#showAmount - 1].getBoundingClientRect().bottom - this.#articleContainer.getBoundingClientRect().top}px`);
    } else {
      this.#articleContainer.style.setProperty("--height", `${this.#articles[this.#articles.length - 1].getBoundingClientRect().bottom - this.#articleContainer.getBoundingClientRect().top}px`);
      this.#readMoreBtn.closest(".horizontal-articles--read-more-container").style.display = "none";
    }
  }
}

customElements.define("horizontal-articles", HorizontalArticles);

class RAOFAQ extends HTMLElement {
  #buttons = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this.#buttons = this.querySelectorAll(".rao-faq__accordion--button");

    for(const button of this.#buttons) {
      button.addEventListener("click", this.#clickHandle.bind(this, button));
    }
  }

  #clickHandle(button) {
    const parent = button.closest(".rao-faq--accordion");

    /*if(parent.classList.contains("selected")) {
      this.querySelector(".rao-faq--accordion.selected").classList.remove("selected");
      this.querySelector(".rao-faq--content.selected").classList.remove("selected");
      return
    }*/

    if(this.querySelector(".rao-faq--accordion.selected")) {
      this.querySelector(".rao-faq--accordion.selected").classList.remove("selected");
    }
    
    if(this.querySelector(".rao-faq--content.selected")) {
      this.querySelector(".rao-faq--content.selected").classList.remove("selected");
    }
    
    const accordionContent = parent.querySelector(".rao-faq__accordion--content");
    const accordionInner = accordionContent.querySelector(".rao-faq__accordion--inner");
    const content = this.querySelector(`.rao-faq--content[data-id="${parent.dataset.id}"]`);

    accordionContent.style.setProperty("--inner-height", `${accordionInner.getBoundingClientRect().height}px`);
    content.classList.add("selected");
    parent.classList.add("selected");
  }
}

customElements.define("rao-faq", RAOFAQ);

class ReviewsLoader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if(document.querySelector("#global-reviews")) {
      this.closest("section").innerHTML = document.querySelector("#global-reviews").innerHTML.replaceAll("placeholder-scroll-id", `scroll-area-${this.closest("section").id}`);
    }
  }
}

customElements.define("reviews-loader", ReviewsLoader);

class RAOAddonAnchor extends HTMLElement {
  constructor() {
    super();
  }

  parse(content) {
    const clonedAnnouncementBar = document.querySelector(".shopify-section--announcement-bar").cloneNode(true);
    clonedAnnouncementBar.querySelector(".announcement-bar--height-observer").style.setProperty("--background-color", "#f2f8ff");
    clonedAnnouncementBar.querySelector(".announcement-bar--height-observer").classList.add("overwrite");
    this.innerHTML = clonedAnnouncementBar.outerHTML + content;
    this.show();
  }

  show() {
    this.setPadding();
    document.documentElement.classList.add('lock');
    this.classList.add("active");
  }

  setPadding() {
    if(document.querySelector(".header--bottom")) {
      document.querySelector(".header--bottom").remove();
    }
  }
}

customElements.define("rao-addon-anchor", RAOAddonAnchor);

class RAOAddonTrigger extends HTMLElement {
  constructor() {
    super();
    this.productId = parseInt(this.dataset.id);
    this.filled = false;
    this.addToCart = this.dataset.addToCart;
    if(this.dataset.filled == "true") {
      this.filled = true;
    }

    this.addEventListener("click", (e) => this.#clickHandle(e));
  }

  async #clickHandle(e) {
    e.preventDefault();

    this.startAnimation();

    if(this.addToCart == "true") {
      if(this.filled) {
        const content = await this.#getAddonContent();
        document.querySelector("rao-addon-anchor").parse(content);
      } else {
        const data = {id: this.productId, quantity: 1};
        await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data)
        });

        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("variant:add"));
      }
      this.stopAnimation();
    } else {
      window.location.href = this.dataset.url;
    }
  }

  startAnimation() {
    this.classList.add("animate");
  }

  stopAnimation() {
    this.classList.remove("animate");
  }

  async #getAddonContent() {
    const url = this.dataset.url;

    const productPageContent = await(await fetch(`https://www.ballonnenshop.nl${url}?view=extra-product-helper`, {
      method: 'GET',
      headers: {
        "Content-Type": "text/html",
        "Cache-Control": "no-cache"
      }
    })).text();

    const response = document.implementation.createHTMLDocument("asd");
    response.body.innerHTML = productPageContent;

    const sections = response.querySelectorAll(".shopify-section:not(.shopify-section-group-header-group):not(.shopify-section-group-overlay-group):not(.shopify-section-group-footer-group)");
    let returnHTML = "";
    for(const section of sections) {
      if(!section.classList.contains("shopify-section-group-footer-group")) {
        returnHTML += section.outerHTML;
      }
    }

    return returnHTML;
  }
}

customElements.define("rao-addon-trigger", RAOAddonTrigger);

class RAOTooltip extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.button = this.querySelector(".rao-tooltip--button");
    this.content = this.querySelector(".rao-tooltip--content");

    if(this.button && this.content) {
      this.button.addEventListener("click", this.open.bind(this));
    }
  }

  open() {
    document.querySelector("rao-tooltip-container").show(this.content.innerHTML);
  }
}

customElements.define("rao-tooltip", RAOTooltip);

class RAOTooltipContainer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const overlay = this.querySelector(".rao-tooltip--overlay");
    const closeBtn = this.querySelector(".rao-tooltip--close-button");

    overlay.addEventListener("click", this.hide.bind(this));
    closeBtn.addEventListener("click", this.hide.bind(this));
  }

  hide() {
    this.classList.remove("open");
  }

  show(content) {
    const inner = this.querySelector(".rao-tooltip--inner");
    inner.innerHTML = content;
    this.classList.add("open");
  }
}

customElements.define("rao-tooltip-container", RAOTooltipContainer);

class RAOAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.content = this.querySelector(".rao-accordion-content__accordion-block--content");
    this.inner = this.querySelector(".rao-accordion-content__accordion-block--inner");
    const button = this.querySelector(".rao-accordion-content__accordion-block--button");

    button.addEventListener("click", this.toggle.bind(this));
  }

  toggle() {
    this.content.style.setProperty("--inner-height", this.inner.getBoundingClientRect().height + "px");
    this.classList.toggle("open");
  }
}

customElements.define("rao-accordion", RAOAccordion);

class RAOPageReadMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const description = this.querySelector(".rao-page--description");
    const lastChild = description.lastElementChild;
    lastChild.innerHTML = lastChild.innerHTML + `<span class="page-read-more--read-less">Lees minder</span>`;

    const readLess = lastChild.querySelector(".page-read-more--read-less");
    readLess.addEventListener("click", function() {
      this.classList.remove("open");
    }.bind(this));

    const readMore = this.querySelector(".page-read-more--read-more");
    readMore.addEventListener("click", function() {
      description.style.setProperty("--full-height", `${lastChild.getBoundingClientRect().bottom - description.getBoundingClientRect().top}px`);
      this.classList.add("open");
    }.bind(this));

    if(lastChild.getBoundingClientRect().bottom != description.getBoundingClientRect().bottom) {
      this.classList.add("active");
    } else {
      this.classList.remove("active");
    }
  }
}

customElements.define("rao-page-read-more", RAOPageReadMore);

class RAOCategory extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const buttons = this.querySelectorAll(".rao-category__category-pages--block");

    for(const button of buttons) {
      button.addEventListener("click", function() {
        const selectedBtn = this.querySelector(".rao-category__category-pages--block.selected");
        const selectedCategory = this.querySelector(".rao-category--sub-categories.selected");

        if(selectedBtn) {
          selectedBtn.classList.remove("selected");
          button.classList.add("selected");
        }

        if(selectedCategory) {
          selectedCategory.classList.remove("selected");
          this.querySelector(`.rao-category--sub-categories[data-index="${button.dataset.index}"]`).classList.add("selected");
        }
      }.bind(this));
    }
  }
}

customElements.define("rao-category", RAOCategory);

class RAOCategoryCollections extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const readMoreContainer = this.querySelector(".rao-category-collections__read-more--container");
    const container = this.querySelector(".rao-category--collections-container");
    const readMoreBtn = this.querySelector(".rao-category-collections__read-more--more");
    const readLessBtn = this.querySelector(".rao-category-collections__read-more--less");
    const items = this.querySelectorAll(".rao-category--collection");
    const lastItem = items[items.length - 1];

    if(window.innerWidth > 999) {
      if(!readMoreContainer.classList.contains("rao-category-collections__read-more--container-hide-desktop")) {
        container.style.setProperty("--small-height", `${items[11].getBoundingClientRect().bottom - container.getBoundingClientRect().top}px`);
      }
    } else if(window.innerWidth > 699) {
      if(!readMoreContainer.classList.contains("rao-category-collections__read-more--container-hide-tablet")) {
        container.style.setProperty("--small-height", `${items[7].getBoundingClientRect().bottom - container.getBoundingClientRect().top}px`);
      }
    } else {
      if(!readMoreContainer.classList.contains("rao-category-collections__read-more--container-hide-mobile")) {
        container.style.setProperty("--small-height", `${items[3].getBoundingClientRect().bottom - container.getBoundingClientRect().top}px`);
      }
    }

    readMoreBtn.addEventListener("click", function() {
      container.style.setProperty("--full-height", `${items[items.length - 1].getBoundingClientRect().bottom - container.getBoundingClientRect().top}px`);
      this.classList.add("open");
    }.bind(this));

    readLessBtn.addEventListener("click", function() {
      if(window.innerWidth > 999) {
        if(!readMoreContainer.classList.contains("rao-category-collections__read-more--container-hide-desktop")) {
          container.style.setProperty("--small-height", `${items[11].getBoundingClientRect().bottom - container.getBoundingClientRect().top}px`);
        }
      } else if(window.innerWidth > 699) {
        if(!readMoreContainer.classList.contains("rao-category-collections__read-more--container-hide-tablet")) {
          container.style.setProperty("--small-height", `${items[7].getBoundingClientRect().bottom - container.getBoundingClientRect().top}px`);
        }
      } else {
        if(!readMoreContainer.classList.contains("rao-category-collections__read-more--container-hide-mobile")) {
          container.style.setProperty("--small-height", `${items[3].getBoundingClientRect().bottom - container.getBoundingClientRect().top}px`);
        }
      }      
      this.classList.remove("open");
      setTimeout(function() {
        this.scrollIntoView({behavior: "smooth", block: "start"})
      }.bind(this), 300);
    }.bind(this));
  }
}

customElements.define("rao-category-collections", RAOCategoryCollections);

class CardDrawerButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    console.log()
    this.addEventListener("click", function() {
      document.querySelector("card-drawer").openCardDrawer(this.dataset.id, this.dataset.content, this.dataset.image, this.dataset.title);
    }.bind(this));
  }
}

customElements.define("card-drawer-button", CardDrawerButton);

class RAOHorizontalProduct extends HTMLElement {
  constructor() {
    super();

    document.addEventListener("cart:change", (e) => this.hideProduct(e));
  }

  connectedCallback() {
    const quickBuyBtn = this.querySelector(".horizontal-product--quick-buy .button");
    quickBuyBtn.addEventListener("click", this.addProductToCart.bind(this));
  }

  async addProductToCart() {
    const data = {id: this.dataset.id, quantity: 1};

    await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data)
    });

    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("variant:add"));
  }

  hideProduct(e) {
    for(const product of e.detail.cart.items) {
      if(product.id == parseInt(this.dataset.id)) {
        this.classList.add("hide");
        return
      }
    }

    this.classList.remove("hide");
  }
}

customElements.define("rao-horizontal-product", RAOHorizontalProduct);

class RAOSEO extends HTMLElement {
  constructor() {
    super();

    const readMoreContainer = this.querySelector(".rao-seo--read-more-container");
    if(readMoreContainer) {
      this.container = this.querySelector(".rao-seo--container");
      this.content = this.querySelector(".rao-seo--content");
      this.desktopMoreContent = this.querySelector(".rao-seo--more-content-desktop");
      this.mobileMoreContent = this.querySelector(".rao-seo--more-content-mobile");
      
      const readMore = readMoreContainer.querySelector(".rao-seo__read-more-button--more");
      const readLess = readMoreContainer.querySelector(".rao-seo__read-more-button--less");

      readMore.addEventListener("click", this.show.bind(this));
      readLess.addEventListener("click", this.hide.bind(this));
    }
  }

  connectedCallback() {
    /*window.addEventListener("resize", function() {
      this.classList.remove("show", "show-more");
    }.bind(this));*/
  }

  show() {
    if(window.innerWidth < 700) {
      this.container.style.setProperty("--default-height", `${this.container.getBoundingClientRect().height}px`);
      this.classList.add("show");
      this.container.style.setProperty("--more-height", `${this.container.getBoundingClientRect().height + this.mobileMoreContent.getBoundingClientRect().height}px`);
      this.classList.add("show-more");
    } else {
      this.content.style.setProperty("--default-height", `${this.content.getBoundingClientRect().height}px`);
      this.classList.add("show");
      this.content.style.setProperty("--more-height", `${this.content.getBoundingClientRect().height + this.desktopMoreContent.getBoundingClientRect().height}px`);
      this.classList.add("show-more");
    }
  }

  hide() {
    this.classList.remove("show-more");
  }
}

customElements.define("rao-seo", RAOSEO);

class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector(".read-more--content");
    this.inner = this.querySelector(".read-more--inner");
    this.moreBtn = this.querySelector(".read-more--more");
    this.lessBtn = this.querySelector(".read-more--less");

    this.moreBtn.addEventListener("click", this.show.bind(this));
    this.lessBtn.addEventListener("click", this.hide.bind(this));
  }

  connectedCallback() {
    if(document.readyState == "complete") {
      if(this.content.getBoundingClientRect().height < this.inner.getBoundingClientRect().height) {
        this.classList.add("show");
      }
    } else {
      window.addEventListener("load", function() {
        if(this.content.getBoundingClientRect().height < this.inner.getBoundingClientRect().height) {
          this.classList.add("show");
        }
      }.bind(this));
    }
  }

  show() {
    this.content.style.setProperty("--inner-height", `${this.inner.getBoundingClientRect().height}px`);
    this.classList.add("show-more");
  }

  hide() {
    this.classList.remove("show-more");
  }
}

customElements.define("read-more", ReadMore);

class FeaturedCollections extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const btns = this.querySelectorAll(".featured-collections__collection-bar--collection");
    for(const btn of btns) {
      btn.addEventListener("click", function() {
        this.querySelector(".featured-collections__collection-bar--collection.selected").classList.remove("selected");
        btn.classList.add("selected");
        this.querySelector(".featured-collections--floating-controls.selected").classList.remove("selected");
        this.querySelector(`.featured-collections--floating-controls[data-id="${btn.dataset.id}"]`).classList.add("selected");
      }.bind(this));
    }
  }
}

customElements.define("featured-collections", FeaturedCollections);

class ASDTooltip extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const shippingBlock = this.querySelector(".product-info--shipping-block");
    if(shippingBlock) {
      const btn = shippingBlock.querySelector(".tooltip-btn svg");
      const tooltip = shippingBlock.querySelector(".product-info--shipping-block--tooltip");
      const headerHeight = document.querySelector('header').getBoundingClientRect().height + document.querySelector('.shopify-section--announcement-bar').getBoundingClientRect().height;
  
      btn.addEventListener("click", function() {
        tooltip.classList.toggle("show");
      });
  
      window.addEventListener('click', function(e) {
        if(tooltip.classList.contains('show')) {
          if(!(tooltip.contains(e.target)) && !(btn.contains(e.target))) {
            tooltip.classList.remove('show');
          }
        }
      });
  
      window.addEventListener("scroll", function() {
        if(!tooltip.classList.contains("show")) {
          if(tooltip.getBoundingClientRect().top - headerHeight < tooltip.getBoundingClientRect().height) {
            tooltip.classList.add('bottom');
          } else {
            tooltip.classList.remove('bottom');
          }
        }
      });
  
      if(tooltip.getBoundingClientRect().top - headerHeight < tooltip.getBoundingClientRect().height) {
        tooltip.classList.add('bottom');
      } else {
        tooltip.classList.remove('bottom');
      }
    }
  }
}

customElements.define("asd-tooltip", ASDTooltip);

class ReedMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.container = this.querySelector('.reed-more--content-container');
    this.content = this.querySelector('.reed-more--content');
    this.toggleBtn = this.querySelector('.toggle-btn');

    this.isExpanded = false;
    this.collapsedHeight = 0;
    this.expandedHeight = 0;
    this.settings = {
      desktopLines: this.getAttribute('line-amount') || 1,
      mobileLines: this.getAttribute('line-amount-mobile') || 1,
      showMoreText: this.getAttribute('show-more-text'),
      showLessText: this.getAttribute('show-less-text')
    };

    window.addEventListener('resize', () => this.toggle(this));

    this.toggleBtn.addEventListener('click', () => {
      this.toggle(this);
    });

    this.update(this);
  }

  toggle(context) {
    context.isExpanded = !context.isExpanded;
    context.content.style.maxHeight = context.isExpanded ? this.expandedHeight + 'px' : context.collapsedHeight + 'px';
    context.toggleBtn.textContent = context.isExpanded ? context.settings.showLessText : context.settings.showMoreText;
    context.update(context);
  }

  update(context) {
    const lineHeight = parseFloat(getComputedStyle(context.content).lineHeight);
    const maxLines = window.innerWidth <= 999 ? context.settings.mobileLines : context.settings.desktopLines;

    if (window.innerWidth <= 999) {
      const toggleBtn = context.content.children[context.settings.desktopLines - 1].querySelector(".toggle-btn-container");
      context.container.setAttribute("style", `--line-amount: ${context.settings.mobileLines}`);
      if (toggleBtn) {
        toggleBtn.remove();
      }
    } else {
      const toggleBtn = context.content.children[context.settings.mobileLines - 1].querySelector(".toggle-btn-container");
      context.container.setAttribute("style", `--line-amount: ${context.settings.desktopLines}`);
      if (toggleBtn) {
        toggleBtn.remove();
      }
    }

    context.collapsedHeight = lineHeight * maxLines;
    context.expandedHeight = context.content.scrollHeight;

    if (!context.isExpanded) {
      context.content.style.maxHeight = context.collapsedHeight + 'px';
      context.container.classList.add('container-collapsed');
      setTimeout(() => {
        context.content.classList.add('collapsed');
      }, 400)
    } else {
      context.content.style.maxHeight = context.expandedHeight + 'px';
      context.container.classList.remove('container-collapsed');
      context.content.classList.remove('collapsed');
    }
  }
}

customElements.define("reed-more", ReedMore);

class RedMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const inner = this.querySelector(".red-more--inner");
    const lineAmount = this.getAttribute('line-amount') || 1;
    const style = window.getComputedStyle(inner);

    this.initEvents(inner);

    this.activeDecider(inner, lineAmount, style);
    window.addEventListener("resize", function() {
      this.activeDecider(inner, lineAmount, style);
    }.bind(this));
  }

  activeDecider(inner, lineAmount, style) {
    const lineHeight = parseFloat(style.getPropertyValue("line-height").replace("px", ""));
    if(parseFloat(inner.getBoundingClientRect().height.toFixed(2)) > parseFloat(lineHeight.toFixed(2))) {
      this.classList.add("show-buttons");
    } else {
      this.classList.remove("show-buttons");
    }

    this.classList.add("show");
  }

  initEvents(inner) {
    const content = this.querySelector(".red-more--content");
    const moreBtn = this.querySelector(".red-more--more");
    const lessBtn = this.querySelector(".red-more--less");

    moreBtn.addEventListener("click", function() {
      content.style.setProperty("--inner-height", `${inner.getBoundingClientRect().height}px`);
      this.classList.add("open");
    }.bind(this));

    lessBtn.addEventListener("click", function() {
      this.classList.remove("open");
    }.bind(this));
  }
}

customElements.define("red-more", RedMore);

class TotalCalculator extends HTMLElement {
  constructor() {
    super();
    this.cartAmount = parseFloat(this.dataset.currentAmount);
  }

  increase(amount) {
    this.cartAmount += parseFloat(amount);
    this.recalculate();
  }

  decrease(amount) {
    this.cartAmount -= parseFloat(amount);
    this.recalculate();
  }

  recalculate() {
    this.innerText = (this.cartAmount / 100).toFixed(2);
    this.dataset.currentAmount = this.cartAmount;
  }
}

customElements.define("total-calculator", TotalCalculator);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();
    this.freeAmount = parseFloat(this.dataset.freeAmount);
    this.cartAmount = parseFloat(this.dataset.cartAmount);
    this.freeText = this.dataset.freeText;
    this.notFreeShippingAmount = parseFloat(this.dataset.notFreeShipping);
  }

  increase(amount) {
    this.cartAmount += parseFloat(amount);
    this.recalculate();
  }

  decrease(amount) {
    this.cartAmount -= parseFloat(amount);
    this.recalculate();
  }

  recalculate() {
    this.dataset.cartAmount = this.cartAmount;
    if(this.cartAmount >= this.freeAmount) {
      this.innerText = this.freeText;
      this.dataset.currentAmount = "0";
    } else {
      this.innerText = (this.notFreeShippingAmount / 100).toFixed(2);
      this.dataset.currentAmount = (this.notFreeShippingAmount / 100).toFixed(2);
    }
  }
}

customElements.define("shipping-calculator", ShippingCalculator);

class AddonSection extends HTMLElement {
  constructor() {
    super();

    this.cart = this.querySelector(".addon-section--cart");
    this.totalCalculator = this.querySelector("total-calculator");
    this.tabs = this.querySelectorAll(".addon-section--tab");
    this.setupTabs();

    setTimeout(function() {
      this.openTab(this.tabs[0], false);
      //this.scrollIntoView({behavior: "smooth", block: "center"});
    }.bind(this),500);    
  
    const checkoutBtn = this.querySelector(".addon-section--add-to-cart");
    checkoutBtn.addEventListener("click", this.addToCart.bind(this));
  }

  setupTabs() {
    for(const tab of this.tabs) {
      this.setupTab(tab);
    }
  }

  setupTab(tab) {
    tab.dataset.top = tab.getBoundingClientRect().top - document.querySelector("rao-addon-anchor").getBoundingClientRect().top;
    const content = tab.querySelector(".addon-section__tab--content");
    const inner = tab.querySelector(".addon-section__tab--inner");
    new ResizeObserver(function() {
      content.style.setProperty('--inner-height', `${inner.getBoundingClientRect().height}px`);
    }).observe(inner);

    const productsContainer = tab.querySelector(".addon-section__tab--products");
      if(productsContainer) {
        let rowShown = 1;

      if(window.innerWidth < 700) {
        rowShown = 2;
      }

      productsContainer.dataset.rowShown = rowShown;
      
      this.showTabProducts(tab, rowShown);
    }

    this.setupProductShowButtons(tab);
    this.handleProductSelection(tab);

    const tabButton = tab.querySelector(".addon-section__tab--accordion-button");
    tabButton.addEventListener("click", this.toggleTab.bind(this, tab));
  }

  openTab(tab, scrollToTab) {
    if(this.querySelector(".addon-section--tab.open")) {
      const closingTab = this.querySelector(".addon-section--tab.open");
      this.closeTab(closingTab);
      
      setTimeout(function() {
        this.getInnerHeight(tab)
        tab.classList.add("open");
        setTimeout(this.scrollTabToView.bind(this, tab), 500);
      }.bind(this), 500);
    } else {
      this.getInnerHeight(tab)
      tab.classList.add("open");
      if(scrollToTab) {
        setTimeout(this.scrollTabToView.bind(this, tab), 500);
      }
    }
  }

  closeTab(tab) {
    tab.classList.remove("open");
  }

  scrollTabToView(tab) {
    tab.scrollIntoView({behavior: "smooth", block: "start"});
  }

  getInnerHeight(tab) {
    const content = tab.querySelector(".addon-section__tab--content");
    const inner = tab.querySelector(".addon-section__tab--inner");

    content.style.setProperty("--inner-height", `${inner.getBoundingClientRect().height}px`);
  }

  toggleTab(tab) {
    if(!tab.classList.contains("open")) {
      this.openTab(tab, true);
    } else {
      this.closeTab(tab);
    }
  }

  showTabProducts(tab, rowShown) {
    const productsContainer = tab.querySelector(".addon-section__tab--products");
    tab.querySelector(".addon-section__tab--content").classList.add("no-transition");

    if(productsContainer) {
      let newRowShown = rowShown ? rowShown : parseInt(productsContainer.dataset.rowShown);
      
      if(!rowShown) {
        if(window.innerWidth < 700) {
          newRowShown += 2;
        } else {
          newRowShown += 1;
        }
      }

      productsContainer.dataset.rowShown = newRowShown;

      let targetIndex = newRowShown * 5 - 1;
      if(window.innerWidth < 700) {
        targetIndex = newRowShown * 2 - 1;
      }

      let targetElement;
      if(productsContainer.children.length < targetIndex) {
        targetElement = productsContainer.lastElementChild;
        tab.querySelector(".addon-section__tab--product-show-container").style.display = "none";
      } else {
        if(productsContainer.children.length-1 == targetIndex) {
          tab.querySelector(".addon-section__tab--product-show-container").style.display = "none";
        }
        targetElement = productsContainer.children[targetIndex];
      }

      productsContainer.style.setProperty("--inner-height", `${targetElement.getBoundingClientRect().bottom - productsContainer.getBoundingClientRect().top}px`);
      setTimeout(function() {
        tab.querySelector(".addon-section__tab--content").classList.remove("no-transition");
      }.bind(this), 500);
    }
  }

  setupProductShowButtons(tab) {
    const showMoreContainer = tab.querySelector(".addon-section__tab--product-show-container");
    if(showMoreContainer) {
      const moreBtn = showMoreContainer.querySelector(".addon-section__tab--product-show-button-more");
      moreBtn.addEventListener("click", (e) => this.showTabProducts(tab));
    }
  }

  handleProductSelection(tab) {
    const productsContainer = tab.querySelector(".addon-section__tab--products");
    if(productsContainer) {
      const products = productsContainer.querySelectorAll(".addon-section__tab--product");
      let selectedProduct = null;
      const textarea = tab.querySelector(".addon-section__tab--textarea");
      const nextBtn = tab.querySelector(".add-section__tab--textarea-button");

      if(textarea && nextBtn) {
        let cartProduct = null;
        for(const product of products) {
          product.addEventListener("click", function() {
            tab.classList.add("product-selected");
            if(product.classList.contains("addon-section__tab--product-empty")) {
              tab.classList.add("empty-product-selected");
            } else {
              tab.classList.remove("empty-product-selected");
            }

            if(selectedProduct) {
              selectedProduct.classList.remove("selected");
            }

            product.classList.add("selected");
            selectedProduct = product;

            if(!product.classList.contains("addon-section__tab--product-empty")) {
              textarea.scrollIntoView({behavior: "smooth", block: "center"});
            } else {
              if(cartProduct) {
                this.removeProductFromCart(cartProduct.querySelector("input").value);
                cartProduct = null;
              }

              tab.classList.add("product-chosen");
              this.closeTab(tab);
              setTimeout(this.openTab.bind(this, tab.nextElementSibling, true), 500);
            }
          }.bind(this));
        }

        nextBtn.addEventListener("click", function() {
          if(cartProduct) {
            this.removeProductFromCart(cartProduct.querySelector("input").value);
          }

          cartProduct = selectedProduct;
          this.addProductToCart(cartProduct, textarea.querySelector("textarea").value);

          tab.classList.add("product-chosen");
          this.closeTab(tab);
          setTimeout(this.openTab.bind(this, tab.nextElementSibling, true), 500);
        }.bind(this));
      } else {
        for(const product of products) {
          product.addEventListener("click", function() {
            tab.classList.add("product-selected");
            if(product.classList.contains("addon-section__tab--product-empty")) {
              tab.classList.add("empty-product-selected");
            } else {
              tab.classList.remove("empty-product-selected");
            }

            if(selectedProduct) {
              selectedProduct.classList.remove("selected");
              if(!selectedProduct.classList.contains("addon-section__tab--product-empty")) {
                this.removeProductFromCart(selectedProduct.querySelector("input").value);
              }
            }

            product.classList.add("selected");
            selectedProduct = product;

            if(!selectedProduct.classList.contains("addon-section__tab--product-empty")) {
              this.addProductToCart(product);
            }

            tab.classList.add("product-chosen");

            this.closeTab(tab);
            setTimeout(this.openTab.bind(this, tab.nextElementSibling, true), 500);
          }.bind(this));
        }
      }
    }
  }

  addProductToCart(product, note) {
    const productsContainer = this.cart.querySelector(".addon-section__cart--products");
    const clone = productsContainer.firstElementChild.cloneNode(true);
    if(note) {
      clone.dataset.note = note;
    }
    clone.dataset.id = product.querySelector("input").value;
    clone.dataset.price = product.dataset.price;
    clone.querySelector(".addon-section__cart--product-image").innerHTML = product.querySelector(".addon-section__tab--product-image").innerHTML;
    clone.querySelector(".addon-section__cart--product-title").innerText = product.querySelector(".addon-section__tab--product-title").innerText;
    clone.querySelector(".addon-section__cart--product-specs").innerHTML = product.querySelector(".addon-section__tab--product-specs").innerHTML;
    clone.querySelector(".addon-section__cart--product-price").innerHTML = product.querySelector(".addon-section__tab--product-content-bottom").innerHTML;
    productsContainer.appendChild(clone);
    this.totalCalculator.increase(parseFloat(product.dataset.price));
    this.totalCalculator.closest(".addon-section__cart--total").classList.add("show");
  }

  removeProductFromCart(id) {
    const cartProduct = this.cart.querySelector(`.addon-section__cart--product[data-id="${id}"]`);
    if(this.cart.querySelectorAll(".addon-section__cart--product").length == 1) {
      this.totalCalculator.closest(".addon-section__cart--total").classList.remove("show");
    }
    this.totalCalculator.decrease(parseFloat(cartProduct.dataset.price));
    if(cartProduct) {
      cartProduct.remove();
    }
  }

  checkTabs() {
    for(let i = 0; i < this.tabs.length - 1; i++) {
      if(!this.tabs[i].classList.contains("product-chosen")) {
        this.openTab(this.tabs[i], true);
        return false
      }
    }

    return true
  }

  async addToCart() {
    this.querySelector(".addon-section--add-to-cart").classList.add("animate");
    const data = {items: []};
    const cartProducts = this.cart.querySelectorAll(".addon-section__cart--product");
    const uid = new Date().valueOf();

    for(let i = cartProducts.length - 1; i >= 0; i--) {
      const item = {id: cartProducts[i].dataset.id, quantity: 1, properties: {_uid: uid}};
      if(cartProducts[i].dataset.note) {
        item.properties["Persoonlijk bericht"] = cartProducts[i].dataset.note;
      }
      if(i == 0) {
        item.properties["_main"] = true;
      } else {
        item.properties["_addon"] = true;
      }
      
      data.items.push(item);
    }

    await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data)
    });

    document.location.href = "/cart";

    /*document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("variant:add"));*/
  }
}

customElements.define('addon-section', AddonSection);

window.addEventListener('DOMContentLoaded', function() {
  /*const productCards = document.querySelectorAll('.rao-product-card');
  for(const productCard of productCards) {
    const quickBuy = productCard.querySelector('.product-card__quick-buy');

    if(quickBuy) {
      productCard.addEventListener('click', function(e) {
        if(quickBuy.contains(e.target)) {
          e.preventDefault();
          quickBuy.querySelector('form')._onSubmit(new SubmitEvent("submit", {submitter: quickBuy.querySelector('form')}));
        }
      });
    }
  }*/

  
  /* Product Page cheat */
  /*const addonContainer = document.querySelector('.product-info--extra-products');
  if(addonContainer) {
    if(window.innerWidth < 699) {
      addonContainer.style.setProperty('--width', `${window.innerWidth - 32}px`);
    }

    window.addEventListener('resize', function() {
      if(window.innerWidth < 699) {
        addonContainer.style.setProperty('--width', `${window.innerWidth - 32}px`);
      }
    });
  }*/
  
  /* Sticky add to cart filled balloons popup */
  /*if(document.querySelectorAll('.product-info__extra-products--item').length != 0) {
    const stickyButtons = document.querySelectorAll('.product-quick-buy--right-side button');
  
    for(const stickyButton of stickyButtons) {
      stickyButton.addEventListener('click', function(e) {
        if(document.querySelectorAll('.product-info__extra-products--item.checked').length == 0) {
          const form = document.querySelector(`form#${stickyButton.getAttribute('form')}`);
          form.classList.add('quick-buy--met-helium');
        }
      });
    }
  }

  const addToCartButtons = document.querySelectorAll('.product-info__block-item[data-block-type="buy-buttons"] button');

  for(const addToCartButton of addToCartButtons) {
    addToCartButton.addEventListener('click', function(e) {
      const form = addToCartButton.closest('form');
      form.classList.remove('quick-buy--met-helium');
    });
  }*/
  
  /* Filled balloons popup */
  const balloonButton = document.querySelector('.product--filled-balloon-button');
  const balloonPopup = document.querySelector('.product__filled-balloon-button--popup');

  if(balloonButton && balloonPopup) {
    const balloonContainer = balloonPopup.querySelector('.product__filled-balloon-button--popup-container');
    const balloonClose = balloonContainer.querySelector('svg');
    
    balloonButton.addEventListener('click', function() {
      balloonPopup.classList.add('open');
      document.documentElement.classList.add('lock');
    });

    balloonPopup.addEventListener('click', function(e) {
      if(!balloonContainer.contains(e.target)) {
        balloonPopup.classList.remove('open');
        document.documentElement.classList.remove('lock');
      }
    });

    balloonClose.addEventListener('click', function(e) {
      balloonPopup.classList.remove('open');
      document.documentElement.classList.remove('lock');
    });
  }
});

/* Infinite Collection */
class RAOCollection extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    if(typeof this.dataset.infiniteLoading != "undefined") {
      this.setupGlobals();
      this.triggers();
    }

    this.checkUSPs()
  }
  
  disconnectedCallback() {
    window.removeEventListener('scroll', this.bs);
  }

  checkUSPs() {
    const usps = this.querySelectorAll(".cllection-usp-container");
    const lastProduct = this.querySelector("product-list").lastElementChild;

    for(const usp of usps) {
      console.log(usp.getBoundingClientRect().top, lastProduct.getBoundingClientRect().bottom);
      if(usp.getBoundingClientRect().top > lastProduct.getBoundingClientRect().bottom) {
        usp.classList.add("cllection-usp-container-hide");
      } else {
        usp.classList.remove("cllection-usp-container-hide");
      }
    }
  }

  async asd() {
    if(this.prevPos == null) {
      this.prevPos = window.scrollY;
    }
    
    if(window.scrollY > this.prevPos) {
      // scrolling down
      if(!this.nextPagesLoaded) {
        if(this.getBoundingClientRect().bottom < window.innerHeight && !this.loading) {
          this.loading = true;
          this.bottomLoad.classList.add('show');
          await this.getNextPage();
          this.loading = false;
          setTimeout(function(){}, 1000);
          this.bottomLoad.classList.remove('show');
        }
      }
      
      this.prevPos = window.scrollY;
      if(this.lastCards[this.currentPage - 1] && !this.loading) {
        const card = this.lastCards[this.currentPage - 1];
        if(card.getBoundingClientRect().top + card.getBoundingClientRect().height * 1.5 < window.innerHeight && card.getBoundingClientRect().top + card.getBoundingClientRect().height * 1.5 > 0) {
          if(this.currentPage + 1 <= this.lastCards.length) {
            this.currentPage += 1;
            this.searchParams.set("page", this.currentPage);
            this.searchParams.delete("section_id");
            window.history.replaceState({}, "", this.url);
          }
        }
      }
    }
    if(window.scrollY < this.prevPos) {
      // scrolling up
      if(!this.prevPagesLoaded && this.currentPage > 1) {
        if(this.getBoundingClientRect().top > -62 && !this.loading) {
          this.loading = true;
          this.topLoad.classList.add('show');
          await this.getPrevPage();
          this.loading = false;
          setTimeout(function(){}, 1000);
          this.topLoad.classList.remove('show');
        }
      }

      this.prevPos = window.scrollY;
      if(this.currentPage > 1 && !this.loading) {
        const card = this.lastCards[this.currentPage - 2];
        if(card) {
          if(card.getBoundingClientRect().top + card.getBoundingClientRect().height * 1.5 > window.innerHeight) {
            this.currentPage -= 1;
            this.searchParams.set("page", this.currentPage);
            this.searchParams.delete("section_id");
            window.history.replaceState({}, "", this.url);
          }
        }
      }
    }
  }

  triggers() {
    this.bs = this.asd.bind(this);
    this.prevPos = null;
    window.addEventListener('scroll', this.bs);
  }

  getLastCards() {
    console.log(this.lastCards);
  }

  setupGlobals() {
    this.sectionId = this.closest('section').id.replace('shopify-section-', '');
    this.productList = this.querySelector('product-list');

    this.topLoad = this.querySelector('.rao-collection--load-more-top');
    this.bottomLoad = this.querySelector('.rao-collection--load-more-bottom');
    
    this.url = new URL(window.location.href);
    this.searchParams = this.url.searchParams;
    this.currentPage = 1;                                                    // Page content what the user sees, changes based on scroll.
    if(this.searchParams.has("page")) {
      this.currentPage = parseInt(this.searchParams.get("page"));
    }

    this.lastCards = [];
    this.lastCards[this.currentPage - 1] = this.productList.children[this.productList.children.length - 1];

    this.prevPagesLoaded = false;
    if(this.currentPage == 1) {
      this.prevPagesLoaded = true;
    }
    this.nextPagesLoaded = false;
  }

  async getPrevPage() {
    const scrollPos = window.scrollY;
    this.searchParams.set("page", this.currentPage - 1);
    this.searchParams.set("section_id", this.sectionId);
    
    const htmlTemp = await (await fetch(this.url, {
      method: "GET",
      headers: {
        "Content-Type": "text/html"
      }
    })).text();

    const html = document.implementation.createHTMLDocument("asd");
    html.body.innerHTML = htmlTemp;

    const newProductCardsContainer = html.querySelector('product-list');
    
    let lastCard;
    for(let i = newProductCardsContainer.children.length - 1; i >= 0; i--) {
      this.productList.prepend(newProductCardsContainer.children[i].cloneNode(true));
    }

    this.lastCards[this.currentPage - 2] = this.productList.children[newProductCardsContainer.children.length - 1];
    this.lastCards[this.currentPage - 2].scrollIntoView();
    
    this.currentPage -= 1;
    this.searchParams.set("page", this.currentPage);

    this.searchParams.delete("section_id");
    window.history.replaceState({}, "", this.url);

    if(this.currentPage == 1) {
      this.prevPagesLoaded = true;
    }

    this.checkUSPs()
  }

  async getNextPage() {
    this.searchParams.set("page", this.currentPage + 1);
    this.searchParams.set("section_id", this.sectionId);
    
    const htmlTemp = await (await fetch(this.url, {
      method: "GET",
      headers: {
        "Content-Type": "text/html"
      }
    })).text();

    const html = document.implementation.createHTMLDocument("asd");
    html.body.innerHTML = htmlTemp;


    const newProductCards = html.querySelectorAll('.rao-product-card');
    if(newProductCards.length == 0) {
      this.nextPagesLoaded = true;
    }

    if(newProductCards.length != 0) {
      for(const newCard of newProductCards) {
        this.productList.appendChild(newCard);
      }

      this.lastCards.push(newProductCards[newProductCards.length - 1]);
      this.currentPage += 1;
      this.searchParams.set("page", this.currentPage);

      this.searchParams.delete("section_id");
      window.history.replaceState({}, "", this.url);
    }

    this.checkUSPs()
  }
}

customElements.define('rao-collection', RAOCollection);

/* RAO Calendar */
class RAOCalendar {
  #monthNames = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];
  #monthLastDays = [31, 30, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  #longDayNames = ["Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag", "Zondag"];
  #blacklistedDates = [];
  #currentDate = new Date();

  constructor(blacklistedDates) {
    this.shortDayNames =  ["Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"];
    if(blacklistedDates) {
      this.#blacklistedDates = blacklistedDates.split(",");
    }
  }

  getMonthName(index) {
    return this.#monthNames[index]
  }

  getMonth(year, month) {
    const date = new Date(`${year}-${month.toString().padStart(2, "0")}-01`);
    const monthObj = {
      month: month,
      monthName: this.#monthNames[month-1],
      year: year,
      days: []
    }

    for(let i = 0; i < this.#monthLastDays[month-1]; i++) {
      const newDate = new Date(date);
      monthObj.days.push(this.getDay(newDate));
      date.setDate(date.getDate() + 1);
      if(date.getMonth() != month-1) {
        break
      }
    }

    return monthObj
  }

  getDay(date) {
    const dayObj = {
      date: date,
      dayNumber: this.#getDayNumber(date.getDay()),
      shortDayName: this.shortDayNames[this.#getDayNumber(date.getDay())],
      longDayName: this.#longDayNames[this.#getDayNumber(date.getDay())],
      available: this.#isDateAvailable(date)
    };

    return dayObj
  }

  getNextAvailableDay(date) {
    while(true) {
      date.setHours(24)
      if(this.#isDateAvailable(date)) {
        return this.getDay(date)
      }
    }
  }

  #isDateAvailable(date) {
    if(this.#isDateToday(date)) {
      return false
    } else if(this.#isDateInThePast(date)) {
      return false
    } else if(date.getDay() == 0) {
      return false
    } else if(this.#isDateBlacklisted(date)) {
      return false
    } else if(this.#cleanDate(date).getTime() - new Date(this.#currentDate).getTime() == 86400000 && new Date(this.#currentDate).getDay() == 5) {
      //return false
    }

    return true
  }

  #isDateToday(dateTemp) {
    const today = new Date(this.#currentDate);
    const date = this.#cleanDate(dateTemp);

    if(date.getTime() == today.getTime()) {
      return true
    }
    return false
  }

  #isDateInThePast(dateTemp) {
    const today = new Date(this.#currentDate);
    const date = this.#cleanDate(dateTemp);

    if(date.getTime() < today.getTime()) {
      return true
    }

    return false
  }

  #isDateBlacklisted(date) {
    return this.#blacklistedDates.includes(`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${(date.getDate()).toString().padStart(2, "0")}`);
  }

  #cleanDate(dateTemp) {
    const date = new Date(this.#currentDate);

    date.setFullYear(dateTemp.getFullYear());
    date.setMonth(dateTemp.getMonth());
    date.setDate(dateTemp.getDate());

    return date
  }

  #getDayNumber(dayNumber) {
    if(dayNumber == 0) {
      return 6
    }
    return dayNumber - 1
  }
}

/* Date Picker Btn */
class RAODatePickerBtn extends HTMLElement {
  constructor() {
    super();

    if(this.dataset.showSelected == "true") {
      this.addEventListener("date-picker:change", (e) => this.#dayChangeEvent(e));
    }
  }

  connectedCallback() {
    const datePicker = document.querySelector("rao-date-picker");
    this.addEventListener("click", function() {
      datePicker.open();
    });
  }

  #dayChangeEvent(e) {
    this.classList.add("show-selected");
    if(this.querySelector(".rao-date-picker--selected-title-long")) {
      this.querySelector(".rao-date-picker--selected-title-long").innerText = e.detail.longDate;
      const titleShort = e.detail.date.split("-");
      this.querySelector(".rao-date-picker--selected-title-short").innerText = `${titleShort[2]}-${titleShort[1]}-${titleShort[0]}`;
    } else {
      this.querySelector(".rao-date-picker--selected-title").innerText = e.detail.longDate;
    }
  }
}

customElements.define("rao-date-picker-btn", RAODatePickerBtn);

/* Date Picker */
class RAODatePicker extends HTMLElement {
  #calendar = new RAOCalendar(this.dataset.blacklistedDates);
  #currDate = new Date();
  #monthBlockIndex = 0;
  #tabsAmount;

  constructor() {
    super();
    this.overlay = this.querySelector(".rao-date-picker--overlay");
    this.container = this.querySelector(".rao-date-picker--container");
    this.addEventListener("date-picker:change", (e) => this.#dayChangeEvent(e));

    window.addEventListener("scroll", function() {
      this.container.style.setProperty("--top-amount", `${this.getBoundingClientRect().bottom}px`);
    }.bind(this));

    this.overlay.addEventListener("click", this.close.bind(this));

    /*window.addEventListener("click", function(e) {
      if(!this.contains(e.target) && !e.target.classList.contains("rao-date-picker--titles") && !e.target.classList.contains("rao-date-picker--default-title") && !e.target.classList.contains("rao-date-picker--selected-title")) {
        this.close();
      }
    }.bind(this));*/

    this.nextBtn = this.querySelector(".rao-date-picker--next");
    this.prevBtn = this.querySelector(".rao-date-picker--previous");

    this.nextBtn.addEventListener("click", this.nextMonth.bind(this));
    this.prevBtn.addEventListener("click", this.prevMonth.bind(this));
  }

  connectedCallback() {
    this.#parseMonths();

    this.#tabsAmount = this.querySelectorAll(".rao-date-picker--block").length;
    this.#defaultSelect();
  }

  open() {
    this.overlay.classList.add("open");
    const topAmount = this.getBoundingClientRect().bottom;
    this.container.style.setProperty("--top-amount", `${topAmount}px`);
    this.container.classList.add("open");
  }

  close() {
    this.overlay.classList.remove("open");
    this.container.classList.remove("open");
  }

  nextMonth() {
    if(!this.nextBtn.classList.contains("disabled")) {
      this.#monthBlockIndex++;
      this.container.style.setProperty("--transform-amount", `${-1 * this.#monthBlockIndex * 100}%`);
      
      this.prevBtn.classList.remove("disabled");
      if(this.#monthBlockIndex == this.#tabsAmount - 2) {
        this.nextBtn.classList.add("disabled");
      }
    }
  }

  prevMonth() {
    if(!this.prevBtn.classList.contains("disabled")) {
      this.#monthBlockIndex--;
      this.container.style.setProperty("--transform-amount", `${-1 * this.#monthBlockIndex * 100}%`);

      this.nextBtn.classList.remove("disabled");
      if(this.#monthBlockIndex == 0) {
        this.prevBtn.classList.add("disabled");
      }
    }
  }

  selectMonth(index) {
    this.#monthBlockIndex = index;
    this.container.style.setProperty("--transform-amount", `${-1 * this.#monthBlockIndex * 100}%`);

    if(this.#monthBlockIndex == 0) {
      this.prevBtn.classList.add("disabled");
    } else {
      this.prevBtn.classList.remove("disabled");
    }

    if(this.#monthBlockIndex == this.#tabsAmount - 2) {
      this.nextBtn.classList.add("disabled");
    } else {
      this.nextBtn.classList.remove("disabled");
    }
  }

  #parseMonths() {
    let month = this.#currDate.getMonth() + 1;
    let year = this.#currDate.getFullYear();
    for(let i = 0; i < 12; i++) {
      this.#parseMonth(year, month);
      month++;
      if(month > 12) {
        year++;
        month = 1;
      }
    }
  }

  #parseMonth(year, month) {
    const monthObj = this.#calendar.getMonth(year, month);

    const monthElement = document.createElement("div");
    monthElement.classList.add("rao-date-picker--block");

    this.#parseDefaultMonthContent(monthObj, monthElement);
    this.#parseDays(monthObj, monthElement);
    

    this.container.appendChild(monthElement);
  }

  #parseDays(monthObj, monthElement) {
    const monthDaysElement = monthElement.querySelector(".rao-date-picker--days");

    this.#parseEmptyDays(monthObj, monthDaysElement);

    for(const day of monthObj.days) {
      const monthDay = document.createElement("span");
      
      monthDay.classList.add("rao-date-picker--day-name");
      if(!day.available) {
        monthDay.classList.add("no-hover", "disabled");
      }
      monthDay.dataset.date = `${day.date.getFullYear()}-${(day.date.getMonth() + 1).toString().padStart(2, "0")}-${(day.date.getDate()).toString().padStart(2, "0")}`;
      monthDay.innerText = day.date.getDate();
      monthDay.addEventListener("click", this.#dayClickHandle.bind(this, monthDay.dataset.date));

      monthDaysElement.appendChild(monthDay);
    }
  }

  #dayClickHandle(date) {
    const day = this.#calendar.getDay(new Date(date));
    const datePickers = document.querySelectorAll("rao-date-picker");
    const dateSliders = document.querySelectorAll("rao-date-slider");
    const dateBtns = document.querySelectorAll("rao-date-picker-btn");
    for(const datePicker of datePickers) {
      datePicker.dispatchEvent(new CustomEvent("date-picker:change", {detail: {date: date}}));
    }
    for(const dateSlider of dateSliders) {
      dateSlider.dispatchEvent(new CustomEvent("date-picker:change", {detail: {date: date}}));
    }
    for(const dateBtn of dateBtns) {
      dateBtn.dispatchEvent(new CustomEvent("date-picker:change", {detail: {date: date, longDate: `${day.longDayName} ${day.date.getDate()} ${this.#calendar.getMonthName(day.date.getMonth())}`}}));
    }
    localStorage.setItem("date", date);
  }

  #dayChangeEvent(event) {
    const chosenDate = this.querySelector(`.rao-date-picker--day-name[data-date="${event.detail.date}"]`);
    if(!chosenDate.classList.contains("disabled")) {
      const selectedDay = this.querySelector(".rao-date-picker--day-name.selected");
      if(selectedDay) {
        selectedDay.classList.remove("selected");
      }

      chosenDate.classList.add("selected");
      this.close();

      const chosenMonth = chosenDate.closest(".rao-date-picker--block");
      this.selectMonth(this.#getMonthIndex(chosenMonth));

      if(this.dataset.dateFormat == "true") {
        /*const day = this.#calendar.getDay(new Date(event.detail.date));
        this.querySelector(".rao-date-picker--titles").classList.add("show-selected");
        this.querySelector(".rao-date-picker--selected-title").innerText = `${day.longDayName} ${day.date.getDate()} ${this.#calendar.getMonthName(day.date.getMonth())}`;*/
      }
    }
  }

  #defaultSelect() {
    const selectedDate = localStorage.getItem("date");
    if(selectedDate) {
      const date = new Date(selectedDate);
      if(date) {
        const day = this.#calendar.getDay(date);
        if(day.available) {
          this.#dayClickHandle(selectedDate);
        } else {
          const nextAvailableDate = this.#calendar.getNextAvailableDay(date);
          this.#dayClickHandle(`${day.date.getFullYear()}-${(day.date.getMonth() + 1).toString().padStart(2, "0")}-${(day.date.getDate()).toString().padStart(2, "0")}`);
        }
      }
    }
  }

  #parseDefaultMonthContent(monthObj, monthElement) {
    const monthName = document.createElement("p");
    monthName.classList.add("rao-date-picker--month");
    monthName.innerText = monthObj.monthName;
    monthElement.appendChild(monthName);

    const monthDays = document.createElement("div");
    monthDays.classList.add("rao-date-picker--days");
    monthElement.appendChild(monthDays);

    for(let i = 0; i < 7; i++) {
      const monthDay = document.createElement("span");
      monthDay.classList.add("rao-date-picker--day-name", "no-hover");
      monthDay.innerText = this.#calendar.shortDayNames[i];
      monthDays.appendChild(monthDay);
    }
  }

  #parseEmptyDays(monthObj, monthDaysElement) {
    for(let i = 0; i < monthObj.days[0].dayNumber; i++) {
      const monthDay = document.createElement("span");
      monthDay.classList.add("rao-date-picker--day-name", "no-hover");
      monthDaysElement.appendChild(monthDay);
    }
  }

  #getMonthIndex(chosenMonthElement) {
    const monthElements = this.container.querySelectorAll(".rao-date-picker--block");
    for(let i = 0; i < monthElements.length; i++) {
      if(monthElements[i] == chosenMonthElement) {
        return i
      }
    }
  }
}

customElements.define('rao-date-picker', RAODatePicker);

class TooltipInfo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const tooltipButton = this.querySelector('svg');
    const tooltipText = this.querySelector('.product-info__extra-products--tooltip-info');
    const headerHeight = document.querySelector('header').getBoundingClientRect().height + document.querySelector('.shopify-section--announcement-bar').getBoundingClientRect().height;

    this.positionContent(tooltipText, headerHeight);
    
    tooltipButton.addEventListener('click', function() {
      tooltipText.classList.add('open');
    });

    window.addEventListener('scroll', function() {
      if(!tooltipText.classList.contains('open')) {
        this.positionContent(tooltipText, headerHeight);
      }
    }.bind(this));
    
    window.addEventListener('click', function(e) {
      if(tooltipText.classList.contains('open')) {
        if(!(this.contains(e.target))) {
          tooltipText.classList.remove('open');
        }
      }
    }.bind(this));
  }

  positionContent(tooltipText, headerHeight) {
    const textInfo = tooltipText.getBoundingClientRect();

    if(this.getBoundingClientRect().top - headerHeight < textInfo.height) {
      tooltipText.classList.add('bottom');
    } else {
      tooltipText.classList.remove('bottom');
    }
  }
}

customElements.define('tooltip-info', TooltipInfo);

class TooltipInfoExtra extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const parentContainer = this.closest('.floating-controls-container');
    const content = this.querySelector('.tooltip-info-extra--content');
    this.parentContent = null;

    this.addEventListener('click', function() {
      this.showContent(parentContainer, content);
    }.bind(this));

    window.addEventListener('click', function(e) {
      if(this.parentContent && this.parentContent.classList.contains('open')) {
        if(!this.contains(e.target) && !this.parentContent.contains(e.target)) {
          this.parentContent.classList.remove('open');
        }
      }
    }.bind(this));
  }

  showContent(parentContainer, content) {
    const copyContent = content.cloneNode(true);
    if(!this.parentContent) {
      parentContainer.appendChild(copyContent);
      this.parentContent = copyContent;
    } else {
      this.parentContent.innerHTML = copyContent.innerHTML;
    }

    const top = this.getBoundingClientRect().top - parentContainer.getBoundingClientRect().top + this.getBoundingClientRect().height;
    this.parentContent.style.setProperty('--top-amount', `${top}px`);

    const left = this.getBoundingClientRect().left - parentContainer.getBoundingClientRect().left;
    let widthMinus = 0;
    if(left > 20) {
      this.parentContent.style.setProperty('--left-amount', "20px");
      widthMinus -= 20;
    }
    if(left < parentContainer.getBoundingClientRect().width - 20) {
      widthMinus -= 20;
    }

    this.parentContent.style.setProperty('--width-amount', `calc(100% + ${widthMinus}px)`);
    this.parentContent.style.setProperty('--point-left-amount', `${left}px`);

    this.parentContent.classList.add('open');
  }
}

customElements.define('tooltip-info-extra', TooltipInfoExtra);

class ExtraProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if(window.innerWidth < 699) {
      this.style.setProperty('--width', `${window.innerWidth - 32}px`);
    }

    window.addEventListener('resize', function() {
      if(window.innerWidth < 699) {
        this.style.setProperty('--width', `${window.innerWidth - 32}px`);
      }
    }. bind(this));
    
    const extraProductButtons = this.querySelectorAll('.product-info__extra-products--button');
    const popupInfoContainer = document.querySelector('.product-info__popup-info--container');

    if(popupInfoContainer) {
      const extraAddonProductButtons = this.querySelectorAll('.product-addons__extra-products--add-button');
      const extraAddonProductRemoveButtons = this.querySelectorAll('.product-addons__extra-products--remove-button span');
      const popupOverlay = document.querySelector('.product-info__popup-info--overlay');
      const popupContainer = document.querySelector('.product-info--popup-info');
      const closeButton = popupContainer.querySelector('.product-info__popup-info--close');
      let scrollPos = 0;

      closeButton.addEventListener('click', function() {
        popupOverlay.classList.remove('open');
        document.documentElement.classList.remove('lock');
        window.scrollTo(0, scrollPos);
      });

      for(const extraAddonProductButton of extraAddonProductButtons) {
        extraAddonProductButton.addEventListener('click', function() {
          extraAddonProductButton.closest('.product-addons__extra-products--product').classList.add('checked');
        });
      }

      for(const extraAddonProductRemoveButton of extraAddonProductRemoveButtons) {
        extraAddonProductRemoveButton.addEventListener('click', function() {
          extraAddonProductRemoveButton.closest('.product-addons__extra-products--product').classList.remove('checked');
        });
      }

      for(const extraProductButton of extraProductButtons) {
        const mainContainer = extraProductButton.closest('.product-info__extra-products--item');
        const productTitle = mainContainer.querySelector('.product-info__extra-products--title span');
        const productImage = mainContainer.querySelector('.product-info__extra-products--image');
        const productPopupInfo = extraProductButton.querySelector('.product-info__extra-products--popup-info');
        
        const removeButton = mainContainer.querySelector('.product-info__extra-products--checkmark span');
        removeButton.addEventListener('click', function() {
          mainContainer.classList.remove('checked');
          mainContainer.querySelector(".product-info__extra-products--item-note").innerHTML = "";
          mainContainer.querySelector('.product-info__extra-products--image img:nth-child(2)').remove();
        });
  
        extraProductButton.addEventListener('click', function() {
          scrollPos = this.openAddonPopup(mainContainer, productPopupInfo, popupInfoContainer, popupContainer, popupOverlay);
        }.bind(this));
        productTitle.addEventListener('click', function() {
          if(!mainContainer.classList.contains('checked')) {
             scrollPos = this.openAddonPopup(mainContainer, productPopupInfo, popupInfoContainer, popupContainer, popupOverlay);
          }
        }.bind(this));
        productImage.addEventListener('click', function() {
          if(!mainContainer.classList.contains('checked')) {
             scrollPos = this.openAddonPopup(mainContainer, productPopupInfo, popupInfoContainer, popupContainer, popupOverlay);
          }
        }.bind(this));
      }
    }
  }

  openAddonPopup(mainContainer, productPopupInfo, popupInfoContainer, popupContainer, popupOverlay) {
    const scrollPos = window.scrollY;
    if(productPopupInfo) {
      /* Copy content to popup and open popup */
      popupInfoContainer.innerHTML = productPopupInfo.innerHTML;

      const input = popupInfoContainer.querySelector('.product-info__popup-info--textarea');
      if(input) {
        input.addEventListener('input', function() {
          input.scrollIntoView();
        });
      }
  
      const imageContainer = popupInfoContainer.querySelector('.product-info__popup-info--images');
      const images = popupInfoContainer.querySelectorAll('.product-info__popup-info--images img');
  
      if(images.length > 6) {
        imageContainer.style.maxHeight = `${images[0].getBoundingClientRect().height * 1.5 + 15}px`;
  
        window.addEventListener('resize', function() {
          imageContainer.style.maxHeight = `${images[0].getBoundingClientRect().height * 1.5 + 15}px`;
        });
      }
      
      const form = popupInfoContainer.querySelector('.product-info__popup-info--form');
  
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const formData = new FormData(form);
  
        mainContainer.querySelector('form').innerHTML = form.innerHTML;
        if(form.querySelector('[name="properties[Persoonlijk bericht]"]')) {
          mainContainer.querySelector('form [name="properties[Persoonlijk bericht]"]').value = form.querySelector('[name="properties[Persoonlijk bericht]"]').value;
        }
        
        mainContainer.classList.add('checked');
  
        const selectedImage = popupInfoContainer.querySelector('.product-info__popup-info--images img.selected');
        
        if(selectedImage) {
          const newImage = document.createElement('img');
          newImage.setAttribute('src', selectedImage.getAttribute('src').replace('"', ''));
          newImage.setAttribute('width', '900');
          newImage.setAttribute('height', '900');
          newImage.setAttribute('sizes', '100px');
          mainContainer.querySelector('.product-info__extra-products--image').appendChild(newImage);
        }
  
        if(formData.get("properties[Persoonlijk bericht]")) {
          mainContainer.querySelector('.product-info__extra-products--item-note').innerHTML = `<li>${formData.get("properties[Persoonlijk bericht]").replace('"', '').replace("\n", "<br>")}</li>`;
        }

        window.scrollTo(0, scrollPos);
        popupInfoContainer.closest('.product-info__popup-info--overlay').classList.remove('open');
        document.documentElement.classList.remove('lock');
      });
  
  
      for(const image of images) {
        image.addEventListener('click', function() {
          const prevImage =  popupInfoContainer.querySelector('.product-info__popup-info--images img.selected');
          if(prevImage) {
            prevImage.classList.remove('selected');
          }
  
          image.classList.add('selected');
          popupInfoContainer.querySelector('input[name="id"]').value = image.dataset.id;
        });
      }
      
      popupContainer.style.setProperty('--top-amount', (window.innerHeight - popupContainer.getBoundingClientRect().height) / 2 + "px");
      setTimeout(function() {
        popupOverlay.classList.add('open');
        document.documentElement.classList.add('lock');
      },100);
    }
  
    return scrollPos;
  }
}

customElements.define('extra-products', ExtraProducts);

window.addEventListener('DOMContentLoaded', function() {
  const extraProductsTemp = document.querySelector('.product-info__extra-products--temp');
  if(extraProductsTemp) {
    extraProductsTemp.addEventListener('click', function(e) {
      if(!extraProductsTemp.firstElementChild.contains(e.target)) {
        extraProductsTemp.firstElementChild.dispatchEvent(new CustomEvent("asd:add"));
      }
    });
  }

  const popupInfoOverlay = document.querySelector('.product-info__popup-info--overlay');
  popupInfoOverlay.addEventListener('click', function(e) {
    if(!popupInfoOverlay.firstElementChild.contains(e.target)) {
      popupInfoOverlay.classList.remove('open');
      document.documentElement.classList.remove('lock');
    }
  });
});

class RAODatePickerCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.container = this.querySelector('.rao-date-picker--container');
    this.blockTemp = this.container.querySelector('.rao-date-picker--block');
    this.blockTemp.remove();
    this.blacklistedDates = this.dataset.blacklistedDates.split(',');
    this.monthAmountShown = parseInt(this.dataset.monthAmountShown);
    this.monthNames = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];
    this.monthLastDays = [31, 30, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    this.dayNames = ["Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"];

    this.createCalendar();
    this.setupEvents();
  }

  setupEvents() {
    const prevButton = this.querySelector('.rao-date-picker--previous');
    const nextButton = this.querySelector('.rao-date-picker--next');
    const inputPicker = this.querySelector('.rao-date-picker--input');
    const inputText = inputPicker.querySelector('.rao-date-picker__input--text');
    const dayItems = this.querySelectorAll('.rao-date-picker--day-name:not(.no-hover)');
    const input = this.querySelector('input');
    this.selectedDay = "";
    
    let currentSlide = 0;

    prevButton.addEventListener('click', function() {
      if(currentSlide != 0) {
        currentSlide--;
        this.container.style.setProperty("--transform-amount", `-${currentSlide * 100}%`);
        if(currentSlide == 0) {
          prevButton.classList.add('disabled');
        }
        nextButton.classList.remove('disabled');
      }
    }.bind(this));

    nextButton.addEventListener('click', function() {
      if(currentSlide != this.container.querySelectorAll('.rao-date-picker--block').length - 1) {
        currentSlide++;
        this.container.style.setProperty("--transform-amount", `-${currentSlide * 100}%`);
        if(currentSlide == this.container.querySelectorAll('.rao-date-picker--block').length - 1) {
          nextButton.classList.add('disabled');
        }
        prevButton.classList.remove('disabled');
      }
    }.bind(this));

    inputPicker.addEventListener('click', function() {
      this.container.classList.toggle('open');
    }.bind(this));

    window.addEventListener('click', function(e) {
      if(this.container.classList.contains('open')) {
        if(!this.contains(e.target)) {
          this.container.classList.remove('open');
        }
      }
    }.bind(this));

    for(const dayItem of dayItems) {
      dayItem.addEventListener('click', function() {
        if(dayItem.classList.contains('selected')) {
          dayItem.classList.remove('selected');
          this.selectedDay = "";
          inputText.innerText = inputText.dataset.placeholder;
          input.value = "";
        } else {
          if(this.selectedDay != "") {
            this.selectedDay.classList.remove('selected');
          }
          
          dayItem.classList.add('selected');
          this.container.classList.remove('open');
          inputText.innerText = dayItem.dataset.date;
          this.selectedDay = dayItem;
          input.value = dayItem.dataset.date;
        }
      }.bind(this));
    }
  }

  createCalendar() {
    this.currentDate = new Date();
    this.firstAvailableDate = new Date();
    this.firstAvailableDate.setHours(24);

    if(this.currentDate.getDay() == 5) {
      if(this.currentDate.getHours() >= 16) {
        this.firstAvailableDate.setHours(72);
      }
    } else if(this.currentDate.getDay() == 6) {
      this.firstAvailableDate.setHours(48);
    } else if(this.currentDate.getDay() == 0) {
      this.firstAvailableDate.setHours(24);
    } else if(this.currentDate.getHours() >= 16) {
      this.firstAvailableDate.setHours(24);
    }

    this.firstAvailableDate = new Date(this.firstAvailableDate);
    let currentMonthIndex = this.currentDate.getMonth();
    let currentYear = this.currentDate.getFullYear();
    
    for(let i = 0; i < this.monthAmountShown; i++) {
      const blockElement = this.blockTemp.cloneNode(true);
      const monthElement = blockElement.querySelector('.rao-date-picker--month');
      const daysContainer = blockElement.querySelector('.rao-date-picker--days');
      if(currentMonthIndex > 11) {
         currentMonthIndex = 0;
        currentYear++;
      }
      monthElement.innerText = this.monthNames[currentMonthIndex];

      this.parseDayNames(daysContainer);
      this.parseWeeks(daysContainer, 1, currentYear, currentMonthIndex);

      currentMonthIndex++;
      this.container.appendChild(blockElement);
    }
  }

  parseDayNames(daysContainer) {
    const weekElement = document.createElement('div');
    weekElement.classList.add('rao-date-picker--week');
    
    for(let i = 0; i < 7; i++) {
      const dayElement = document.createElement('span');
      dayElement.classList.add('rao-date-picker--day-name');
      dayElement.classList.add('no-hover');

      dayElement.innerText = this.dayNames[i];
      weekElement.appendChild(dayElement);
    }

    daysContainer.appendChild(weekElement);
  }

  parseWeeks(daysContainer, startingDay, year, monthIndex) {
    let monthIndexTemp = monthIndex;
    let monthLastDay = 28;

    if(monthIndex != 1) {
      monthLastDay = this.monthLastDays[monthIndex];
    } else {
      if(new Date(`${year}-${monthIndex + 1}-29`).getMonth() == monthIndex) {
        monthLastDay = 29;
      } else {
        monthLastDay = 28;
      }
    }

    if(startingDay <= monthLastDay) {
      let date = new Date(`${year}-${(monthIndex + 1).toString().padStart(2, "0")}-${startingDay.toString().padStart(2, "0")}`);
      const weekElement = document.createElement('div');
      weekElement.classList.add('rao-date-picker--week');
      let counter = 0;

      for(let i = 0; i < 7; i++) {
        if(parseInt(startingDay)+i > monthLastDay) {
          break;
        }
        
        const dayElement = document.createElement('span');
        dayElement.classList.add('rao-date-picker--day-name');

        let getDay = date.getDay();
        if(getDay == 0) {
          getDay = 7;
        }
        if(i + 1 == getDay) {
          if(this.blacklistedDates.includes(`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${(date.getDate()).toString().padStart(2, "0")}`)) {
            dayElement.classList.add('no-hover');
            dayElement.classList.add('disabled');
          }

          if(date < this.firstAvailableDate) {
            dayElement.classList.add('no-hover');
            dayElement.classList.add('disabled');
          }

          dayElement.innerText = date.getDate();
          dayElement.dataset.date = `${(date.getDate()).toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
          date.setDate(date.getDate() + 1);
          counter++;
        } else {
          dayElement.classList.add('no-hover');
        }

        weekElement.appendChild(dayElement);
      }

      daysContainer.appendChild(weekElement);
      if(parseInt(startingDay)+counter <= monthLastDay) {
        this.parseWeeks(daysContainer, parseInt(startingDay)+counter, date.getFullYear(), date.getMonth());
      }
    }
  }
}

customElements.define('rao-date-picker-cart', RAODatePickerCart);


